import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link, useParams } from 'react-router-dom';
import { popularComicsData } from '@/pages/home/components/PopularGrid';
import PopularGrid from '@/pages/home/components/PopularGrid';
import TestimonialSection from '@/pages/home/components/TestimonialSection';
import { getCategorySlug } from '@/utils/categories';

const comicImages: Record<string, string> = {
  'comic-1': 'https://readdy.ai/api/search-image?query=Stylized%20digital%20art%20cover%20of%20a%20Korean%20manhwa%20featuring%20a%20dark-haired%20protagonist%20with%20glowing%20blue%20eyes%20standing%20in%20a%20ruined%20cityscape%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20cool%20blue%20and%20deep%20black%20tones%2C%20painterly%20style%2C%20epic%20fantasy%20atmosphere%2C%20soft%20background%20gradient%2C%20professional%20illustration&width=800&height=1067&seq=detail-comic-01&orientation=portrait',
  'comic-2': 'https://readdy.ai/api/search-image?query=Vertical%20Korean%20webtoon%20cover%20art%20of%20a%20mysterious%20young%20man%20wearing%20a%20long%20black%20coat%20reading%20an%20ancient%20glowing%20book%2C%20ethereal%20golden%20particles%20floating%20around%2C%20mystical%20library%20background%20with%20warm%20amber%20lighting%2C%20fantasy%20aesthetic%2C%20clean%20composition%2C%20soft%20dreamlike%20atmosphere&width=800&height=1067&seq=detail-comic-02&orientation=portrait',
  'comic-3': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%20of%20a%20handsome%20swordsman%20with%20flowing%20dark%20hair%20in%20traditional%20martial%20arts%20robes%2C%20cherry%20blossoms%20falling%20around%20him%2C%20misty%20mountain%20background%20with%20soft%20pink%20and%20sage%20green%20tones%2C%20wuxia%20fantasy%20style%2C%20elegant%20composition&width=800&height=1067&seq=detail-comic-03&orientation=portrait',
  'comic-4': 'https://readdy.ai/api/search-image?query=Vertical%20elegant%20Korean%20romance%20manhwa%20cover%20featuring%20a%20beautiful%20noblewoman%20in%20an%20elaborate%20Victorian-style%20dress%20with%20golden%20embroidery%2C%20standing%20in%20a%20palace%20ballroom%2C%20soft%20warm%20candlelight%20glow%2C%20rose%20gold%20and%20cream%20tones&width=800&height=1067&seq=detail-comic-04&orientation=portrait',
  'comic-5': 'https://readdy.ai/api/search-image?query=Korean%20modern%20drama%20manhwa%20cover%20art%20of%20a%20confident%20businessman%20in%20a%20tailored%20suit%20standing%20in%20front%20of%20a%20glass%20skyscraper%2C%20city%20lights%20reflecting%20in%20the%20background%2C%20sophisticated%20urban%20atmosphere%2C%20cool%20grey%20and%20navy%20tones&width=800&height=1067&seq=detail-comic-05&orientation=portrait',
  'comic-6': 'https://readdy.ai/api/search-image?query=Korean%20beauty%20romance%20manhwa%20cover%20featuring%20a%20stunning%20young%20woman%20with%20flawless%20makeup%20and%20flowing%20brown%20hair%2C%20soft%20pastel%20pink%20and%20peach%20background%20with%20cherry%20blossom%20petals%2C%20warm%20gentle%20lighting%2C%20school%20uniform%20aesthetic&width=800&height=1067&seq=detail-comic-06&orientation=portrait',
  'comic-7': 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20of%20a%20young%20nobleman%20with%20silver%20hair%20and%20piercing%20red%20eyes%20holding%20a%20magical%20artifact%2C%20dark%20gothic%20mansion%20interior%20background%20with%20candlelight%2C%20mysterious%20royal%20atmosphere%2C%20deep%20burgundy%20and%20charcoal%20tones&width=800&height=1067&seq=detail-comic-07&orientation=portrait',
  'comic-8': 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%20art%20of%20a%20fierce%20hunter%20wielding%20dual%20glowing%20daggers%20in%20a%20monster-filled%20dungeon%2C%20dynamic%20action%20pose%2C%20neon%20blue%20energy%20effects%2C%20dark%20cavern%20background%20with%20bioluminescent%20crystals&width=800&height=1067&seq=detail-comic-08&orientation=portrait',
};

const comicDetails: Record<string, { description: string; tags: string[]; chapters: { num: number; title: string; date: string }[] }> = {
  'comic-1': {
    description: '在一个突然出现"门"的世界里，怪物从门中涌出，猎人们获得了特殊能力来对抗这些怪物。成振宇，被称为"人类最弱的E级猎人"，在一次近乎致命的双重地下城事件后，获得了一个神秘的系统，使他能够无限升级。从一个最弱的猎人开始，逐步成为世界上最强的存在...',
    tags: ['热血', '奇幻', '升级流', '战斗', '系统'],
    chapters: Array.from({ length: 20 }, (_, i) => ({ num: 201 - i, title: `第${201 - i}话`, date: `2026-0${Math.max(1, 7 - Math.floor(i / 4))}-${String((i % 28) + 1).padStart(2, '0')}` })),
  },
  'comic-2': {
    description: '金独子是一个普通的上班族，十年来他一直在阅读一部名为《在灭亡的世界中生存的三种方法》的网络小说。当小说的最后一章发布时，小说中的世界突然变成了现实。作为唯一知道整个故事走向的人，金独子必须利用他对剧情的了解，在这个末日世界中生存下去...',
    tags: ['奇幻', '末世', '穿越', '策略', '生存'],
    chapters: Array.from({ length: 20 }, (_, i) => ({ num: 235 - i, title: `第${235 - i}话`, date: `2026-0${Math.max(1, 7 - Math.floor(i / 4))}-${String((i % 28) + 1).padStart(2, '0')}` })),
  },
  'comic-3': {
    description: '传说中的剑尊在击败魔王后死亡，却意外重生回到了自己的青年时代。带着前世的记忆和绝世武功，他决定这一次不再独自承担一切，而是要享受青春，过上自己想要的生活。然而，前世的责任和危机依然在悄然逼近...',
    tags: ['武侠', '重生', '校园', '战斗', '轻松'],
    chapters: Array.from({ length: 20 }, (_, i) => ({ num: 188 - i, title: `第${188 - i}话`, date: `2026-0${Math.max(1, 7 - Math.floor(i / 4))}-${String((i % 28) + 1).padStart(2, '0')}` })),
  },
  'comic-4': {
    description: '成为提线木偶的恶女公主，被系统赋予了全新的命运。为了摆脱被控制的宿命，她开始用自己的方式改写故事。一场关于权力、爱情和自由的宫廷传奇就此展开...',
    tags: ['恋爱', '宫廷', '重生', '逆袭', '女强'],
    chapters: Array.from({ length: 20 }, (_, i) => ({ num: 156 - i, title: `第${156 - i}话`, date: `2026-0${Math.max(1, 7 - Math.floor(i / 4))}-${String((i % 28) + 1).padStart(2, '0')}` })),
  },
  'comic-5': {
    description: '一个普通青年入赘豪门后，面对妻子家族的轻视与外界的质疑，凭借自己的智慧和能力一步步证明自己，在都市商战中披荆斩棘，最终赢得尊重和爱情的故事...',
    tags: ['都市', '商战', '逆袭', '恋爱', '励志'],
    chapters: Array.from({ length: 20 }, (_, i) => ({ num: 312 - i, title: `第${312 - i}话`, date: `2026-0${Math.max(1, 7 - Math.floor(i / 4))}-${String((i % 28) + 1).padStart(2, '0')}` })),
  },
  'comic-6': {
    description: '因为长相平凡而在学校备受欺凌的女生林珠京，通过化妆技巧彻底改变了自己的外貌，成为了校园女神。然而她必须在"素颜的自己"和"化妆后的自己"之间维持平衡，同时面对校园生活、友情和爱情的种种考验...',
    tags: ['校园', '恋爱', '成长', '美妆', '友情'],
    chapters: Array.from({ length: 20 }, (_, i) => ({ num: 267 - i, title: `第${267 - i}话`, date: `2026-0${Math.max(1, 7 - Math.floor(i / 4))}-${String((i % 28) + 1).padStart(2, '0')}` })),
  },
  'comic-7': {
    description: '伯爵家的废物少爷，在所有人都对他失望的时候，觉醒了隐藏的血脉之力。被家族流放后，他在荒野中不断成长，结识了各路伙伴。当黑暗势力威胁到整个王国时，这个曾经的"废物"成为了最后的希望...',
    tags: ['奇幻', '成长', '冒险', '魔法', '逆袭'],
    chapters: Array.from({ length: 20 }, (_, i) => ({ num: 198 - i, title: `第${198 - i}话`, date: `2026-0${Math.max(1, 7 - Math.floor(i / 4))}-${String((i % 28) + 1).padStart(2, '0')}` })),
  },
  'comic-8': {
    description: '在SSS级地下城中死亡的顶级猎人，意外获得重生机会并回到了一年前。带着对未来的完整记忆，他重新踏上猎人生涯，这一次他要弥补所有遗憾，阻止即将降临的世界级灾难...',
    tags: ['热血', '重生', '战斗', '升级', '冒险'],
    chapters: Array.from({ length: 20 }, (_, i) => ({ num: 176 - i, title: `第${176 - i}话`, date: `2026-0${Math.max(1, 7 - Math.floor(i / 4))}-${String((i % 28) + 1).padStart(2, '0')}` })),
  },
};

export default function ComicDetailPage() {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const comic = popularComicsData.find((c) => c.id === slug);
  const detail = comicDetails[slug || ''] || { description: '暂无简介', tags: [], chapters: [] };
  const categorySlug = comic ? getCategorySlug(comic.category) : 'quanbu';

  if (!comic) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen flex items-center justify-center bg-background-50">
          <div className="text-center py-20">
            <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-background-200 flex items-center justify-center">
              <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
            </div>
            <h1 className="text-xl font-bold text-foreground-900 mb-2">未找到该漫画</h1>
            <p className="text-sm text-foreground-500 mb-6">您访问的漫画不存在或已下架</p>
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-arrow-left-line"></i>
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main>
        <section className="bg-background-50 pt-24 pb-12 md:pb-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <Link to="/category/all" className="hover:text-primary-500 transition-colors cursor-pointer">{comic.category}</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-800">{comic.title}</span>
            </nav>

            <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
              <div className="lg:w-[380px] flex-shrink-0">
                <div className="rounded-3xl overflow-hidden bg-background-100">
                  <img
                    src={comicImages[comic.id] || comicImages['comic-1']}
                    alt={comic.title}
                    title={`${comic.title} - 韩漫免费在线观看`}
                    className="w-full aspect-[3/4] object-cover object-top"
                  />
                </div>
              </div>

              <div className="flex-1 flex flex-col justify-center">
                <div className="mb-4">
                  <Link
                    to="/category/all"
                    className="inline-block px-3 py-1 bg-accent-100 text-accent-600 text-xs font-medium rounded-full hover:bg-accent-200 transition-colors cursor-pointer"
                  >
                    {comic.category}
                  </Link>
                </div>
                <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight mb-3">
                  {comic.title}
                </h1>
                <p className="text-sm text-foreground-500 mb-5">作者：{comic.author}</p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-xl">
                  {detail.description}
                </p>

                <div className="flex flex-wrap gap-2 mb-6">
                  {detail.tags.map((tag) => (
                    <span key={tag} className="px-3 py-1 bg-background-100 text-foreground-600 text-xs rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="flex items-center gap-4 mb-8">
                  <div className="flex items-center gap-2">
                    <span className="text-2xl font-bold text-primary-500">{comic.rating}</span>
                    <span className="text-xs text-foreground-500">/ 10</span>
                  </div>
                  <div className="w-px h-6 bg-background-300"></div>
                  <div>
                    <span className="text-sm font-medium text-foreground-800">{comic.chapterCount}话</span>
                    <span className="text-xs text-foreground-500 ml-1">共</span>
                  </div>
                  <div className="w-px h-6 bg-background-300"></div>
                  <span className={`text-sm font-medium ${comic.status === '连载中' ? 'text-primary-500' : 'text-accent-500'}`}>
                    {comic.status}
                  </span>
                </div>

                <button className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap w-fit">
                  开始阅读第一话
                  <i className="ri-arrow-right-up-line"></i>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-12 md:py-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mb-8">章节目录</h2>
            <div className="bg-background-50 rounded-3xl overflow-hidden">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
                {detail.chapters.map((chapter) => (
                  <a
                    key={chapter.num}
                    href="#"
                    className="flex items-center justify-between px-5 py-4 hover:bg-background-100 transition-colors cursor-pointer border-b border-background-200/60 last:border-b-0"
                  >
                    <span className="text-sm font-medium text-foreground-800">{chapter.title}</span>
                    <span className="text-xs text-foreground-500">{chapter.date}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </section>

        <PopularGrid />
        <TestimonialSection />
      </main>
      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": `${comic.title} - 韩漫免费在线观看`,
          "description": detail.description,
          "author": { "@type": "Person", "name": comic.author },
          "datePublished": "2026-01-15",
          "dateModified": "2026-07-03",
          "url": `http://bestyoungman.com/comic/${comic.id}`,
          "publisher": { "@type": "Organization", "name": "韩漫网站", "url": "http://bestyoungman.com/" },
          "image": comicImages[comic.id],
          "articleSection": comic.category,
          "mainEntityOfPage": { "@type": "WebPage", "@id": `http://bestyoungman.com/comic/${comic.id}` }
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://bestyoungman.com/" },
            { "@type": "ListItem", "position": 2, "name": comic.category, "item": 'http://bestyoungman.com/category/all' },
            { "@type": "ListItem", "position": 3, "name": comic.title, "item": `http://bestyoungman.com/comic/${comic.id}` }
          ]
        })}
      </script>
    </>
  );
}